import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeypad = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.8 3.8H6.2V6.2H3.8V3.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.8 3.8H11.2V6.2H8.8V3.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8 3.8H16.2V6.2H13.8V3.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.8 8.8H6.2V11.2H3.8V8.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.8 8.8H11.2V11.2H8.8V8.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8 8.8H16.2V11.2H13.8V8.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.8 13.8H6.2V16.2H3.8V13.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.8 13.8H11.2V16.2H8.8V13.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8 13.8H16.2V16.2H13.8V13.8Z",
			fill: "currentColor"
		})
	]
});
export default SvgKeypad;
